import React from 'react';
import PropTypes from 'prop-types';

const BrickMetadata = props => (

  <div className="brick-metadata">
    <a
      href={props.watchUrl}
      onClick={props.onCTAClick}
      title={props.title}
      target="_blank"
      rel="noopener noreferrer"
    >
      {props.title}
    </a>
    <span className="year">{props.year}</span>

    {props.hideUserActions ? null :
    <span className="queue-count">{props.numberOfQueues}</span>
    }

  </div>
);

BrickMetadata.propTypes = {
  watchUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired,
  numberOfQueues: PropTypes.number.isRequired,
  onCTAClick: PropTypes.func.isRequired,
  hideUserActions: PropTypes.bool.isRequired,
};

export default BrickMetadata;



// WEBPACK FOOTER //
// ./src/client/components/brick-metadata.jsx